var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: { active: _vm.isVisible, "popup-overlay": 1 } }, [
    _c("div", { staticClass: "popup-dialog mybaumit-dialog" }, [
      _c("div", { staticClass: "close", on: { click: _vm.close } }, [
        _vm._v("×")
      ]),
      _c("div", [
        _c("form", [
          _c("h3", [_vm._v(_vm._s(_vm.trans("registration")))]),
          _c("div", { staticClass: "inputs" }, [
            _vm.targetGroups.length > 1
              ? _c("div", { staticClass: "form-group" }, [
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.target_group_id,
                          expression: "target_group_id"
                        }
                      ],
                      staticClass: "form-control",
                      attrs: { name: "target_group_id", id: "target_group_id" },
                      on: {
                        change: function($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function(o) {
                              return o.selected
                            })
                            .map(function(o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.target_group_id = $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        }
                      }
                    },
                    _vm._l(_vm.targetGroups, function(targetGroup) {
                      return _c(
                        "option",
                        {
                          key: targetGroup.id,
                          domProps: { value: targetGroup.id }
                        },
                        [_vm._v(_vm._s(targetGroup.name))]
                      )
                    }),
                    0
                  )
                ])
              : _vm._e(),
            _c("div", { staticClass: "form-group" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.email,
                    expression: "email"
                  },
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required|email",
                    expression: "'required|email'"
                  }
                ],
                staticClass: "form-control",
                attrs: {
                  name: "email",
                  type: "email",
                  placeholder: _vm.trans("form_email")
                },
                domProps: { value: _vm.email },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.email = $event.target.value
                  }
                }
              }),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showError("email"),
                      expression: "showError('email')"
                    }
                  ],
                  staticClass: "validation-error"
                },
                [_vm._v(_vm._s(_vm.errors.first("email")))]
              )
            ]),
            _c("div", { staticClass: "form-group" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.password,
                    expression: "password"
                  },
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required|min:3",
                    expression: "'required|min:3'"
                  }
                ],
                staticClass: "form-control",
                attrs: {
                  type: "password",
                  name: "password",
                  placeholder: _vm.trans("form_pwd")
                },
                domProps: { value: _vm.password },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.password = $event.target.value
                  }
                }
              }),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showError("password"),
                      expression: "showError('password')"
                    }
                  ],
                  staticClass: "validation-error"
                },
                [_vm._v(_vm._s(_vm.errors.first("password")))]
              )
            ]),
            _c("div", { staticClass: "form-group" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.first_name,
                    expression: "first_name"
                  },
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required|min:3",
                    expression: "'required|min:3'"
                  }
                ],
                staticClass: "form-control",
                attrs: {
                  name: "first_name",
                  placeholder: _vm.trans("form_first_name")
                },
                domProps: { value: _vm.first_name },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.first_name = $event.target.value
                  }
                }
              }),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showError("first_name"),
                      expression: "showError('first_name')"
                    }
                  ],
                  staticClass: "validation-error"
                },
                [_vm._v(_vm._s(_vm.errors.first("first_name")))]
              )
            ]),
            _c("div", { staticClass: "form-group" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.last_name,
                    expression: "last_name"
                  },
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required|min:3",
                    expression: "'required|min:3'"
                  }
                ],
                staticClass: "form-control",
                attrs: {
                  name: "last_name",
                  placeholder: _vm.trans("form_last_name")
                },
                domProps: { value: _vm.last_name },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.last_name = $event.target.value
                  }
                }
              }),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showError("last_name"),
                      expression: "showError('last_name')"
                    }
                  ],
                  staticClass: "validation-error"
                },
                [_vm._v(_vm._s(_vm.errors.first("last_name")))]
              )
            ]),
            _c("div", { staticClass: "form-check mt-5" }, [
              _c("label", { staticClass: "form-check-label" }, [
                _c("span", {
                  staticClass: "mdi mdi-name",
                  attrs: { for: "agree" }
                }),
                _c("p", {
                  domProps: {
                    innerHTML: _vm._s(_vm.trans("form_privacy_policy"))
                  }
                }),
                _c("input", {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "required",
                      expression: "'required'"
                    }
                  ],
                  staticClass: "form-check-input",
                  attrs: { type: "checkbox", id: "pp_agree", name: "pp_agree" }
                })
              ])
            ]),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.showError("pp_agree"),
                    expression: "showError('pp_agree')"
                  }
                ],
                staticClass: "validation-error"
              },
              [_vm._v(_vm._s(_vm.errors.first("pp_agree")))]
            ),
            _c("div", {
              staticClass: "g-recaptcha",
              attrs: {
                id: "reg-recaptcha",
                "data-sitekey": "6Lcbfk0UAAAAAIP7DZbkxEAbVhqPjLzSwkX4QsFl"
              }
            }),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.showError("g-recaptcha-response"),
                    expression: "showError('g-recaptcha-response')"
                  }
                ],
                staticClass: "validation-error"
              },
              [_vm._v(_vm._s(_vm.errors.first("g-recaptcha-response")))]
            )
          ]),
          _c("div", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.customErrors.length > 0,
                expression: "customErrors.length>0"
              }
            ],
            staticClass: "clearfix validation-error",
            domProps: { innerHTML: _vm._s(_vm.customErrorsText) }
          }),
          _c("div", { staticClass: "clearfix mt-4" }, [
            _c(
              "button",
              {
                staticClass: "button type-2 pull-right",
                attrs: { type: "button" },
                on: {
                  click: function($event) {
                    return _vm.register(true)
                  }
                }
              },
              [_vm._v(_vm._s(_vm.trans("button_submit")))]
            )
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }